<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <!-- <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs> -->
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium"
            >Registro de orden de servicio</span
          >
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-menu rounded="0" offset-y>
            <template
              v-slot:activator="{ attrs, on }"
              v-if="this.$hasPermision('solicitud-venta.create')"
            >
              <v-btn
                color="#023145"
                class="white--text float-right"
                v-bind="attrs"
                v-on="on"
                @click="handleShowCreate"
              >
                Nuevo
              </v-btn>
            </template>
          </v-menu>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" class="pt-1">
          <v-text-field
            v-model="search_sale"
            label="Buscar por Nombres o apellidos"
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchByEnter"
          >
          </v-text-field>
        </v-col>
        <v-col cols="5" class="pt-1">
          <v-btn class="w-btn-search" height="40" @click="handleSearch">
            Buscar
          </v-btn>
        </v-col>
        <v-col cols="3" class="pt-1">
          <v-btn
            v-if="this.$hasPermision('solicitud-venta.filters')"
            dark
            color="#023145"
            outlined
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            <v-icon class="mr-2" size="14">fas fa-sort-amount-down</v-icon>
            Ver Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-data-table
              v-model="selectedRows"
              :headers="headers"
              :items="solicitud"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              show-select
              :single-select="true"
              @item-selected="handleSelectItem"
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="
                    ml-3
                    pt-3
                    pb-3
                    subtitle-1
                    font-weight-bold
                    w-title-table
                  "
                >
                  Todos los registros
                </span>
                <v-divider></v-divider>
              </template>
              <template v-slot:item.order_code="{ item }">
                <div v-if="item.canceled" class="sale-cancel">
                  {{ item.order_code }}
                </div>
                <div v-else>{{ item.order_code }}</div>
              </template>
              <!-- <template v-slot:item.fullname="{ item }">
                <div v-if="item.canceled" class="sale-cancel">
                  {{ item.fullname }}
                </div>
                <div v-else>{{ item.fullname }}</div>
              </template> -->
              <template v-slot:item.customer_fullname="{ item }">
                <div v-if="item.canceled" class="sale-cancel">
                  {{ item.customer_surname + " " + item.customer_name }}
                </div>
                <div v-else>
                  {{ item.customer_surname + " " + item.customer_name }}
                </div>
              </template>
              <template v-slot:item.document="{ item }">
                <div v-if="item.canceled" class="sale-cancel">
                  {{ item.document }}
                </div>
                <div v-else>{{ item.document }}</div>
              </template>
              <template v-slot:item.registration_date="{ item }">
                <div v-if="item.canceled" class="sale-cancel">
                  {{ item.registration_date }}
                </div>
                <div v-else>{{ item.registration_date }}</div>
              </template>

              <!-- <template v-slot:item.doctor.fullname="{item}">
                              <div v-if="item.canceled"  class="sale-cancel">{{item.registration_date}}</div>
                              <div v-else>{{item.registration_date}}</div>
                            </template> -->

              <template v-slot:item.orden="{ item }">
                <v-btn
                  v-if="!item.canceled"
                  icon
                  small
                  dark
                  color="blue"
                  @click="handlePrintVoucher(item)"
                >
                  <v-icon size="20">fas fa-print</v-icon>
                </v-btn>

                <v-btn
                  v-if="!item.canceled"
                  icon
                  small
                  dark
                  color="red"
                  @click="handleCancelInvoice(item)"
                >
                  <v-icon size="14">far fa-times-circle</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <Filters ref="filters" @hanleChangeFilter="hanleChangeFilter"></Filters>

    <download-products ref="downloadProducts"></download-products>
    <upload-products ref="uploadProducts"></upload-products>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import router from "@/router/index";
import ArrayTools from "../../../helpers/ArrayTools";
// import Filters from '../../../components/products/Filters';
import Filters from "../../../components/atencion-orden-servicio/Filters";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import DownloadProducts from "../../../components/products/DownloadProducts";
import UploadProducts from "../../../components/products/UploadProducts";

import TicketToolsSolicitud from "../../../helpers/TicketToolsSolicitud";
import JQuery from "jquery";
let $ = JQuery;

import SalesApi from "../../../apis/Sales";
import SolicitudApi from "../../../apis/Solicitud";

export default {
  name: "Requests",
  components: {
    Filters,
    OfficeLogin,
    DownloadProducts,
    UploadProducts,
  },
  data() {
    return {
      category_selected: null,
      show_celulares: false,
      show_accesorios: true,
      show_chips: false,
      title_table: null,
      search_sale: null,
      drawer: false,
      show_options_crud: false,
      show_btn_active: false,
      selectedRows: [],
      salesAux: [],
      itemsBreadcrumbs: [
        {
          text: "Atención",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "NRO ORDEN", value: "order_code" },
        // { text: "PACIENTE", value: "fullname" },
        { text: "PACIENTE", value: "customer_fullname" },
        { text: "DNI", value: "customer_document" },
        { text: "FECHA REGISTRO", value: "registration_date" },
        // { text: "MÉDICO", value: "doctor.fullname" },
        { text: "MÉDICO", value: "doctor_fullname" },
        // { text: "EMPRESA", value: "company_customer.name" },
        { text: "CLIENTE", value: "company_customer_name" },
        // { text: "TOTAL", value: "total", width: 90 },
        {
          text: "ORDEN TRABAJO",
          value: "orden",
          sortable: false,
          align: "center",
        },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
      filterAux: {},
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getSolicitudes({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
          office_id: this.office_id,
          ...this.filterAux,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("authentication", ["office_id"]),
    ...mapState("offices", ["offices"]),
    ...mapState("sales", ["sale", "selected_sale", "solicitud", "paginated"]),
    ...mapState("categories", ["categories"]),
    ...mapState("report-sales", ["voucher", "voucher_solicitud"]),
  },
  methods: {
    /*1par=modulo, 2par=metodos */
    ...mapActions("sales", [
      "getSales",
      "change_status",
      "delete",
      "runCleanSales",
      "selectSale",
      "emptySales",
      "getSolicitudes",
      "cancelSolicitud",
      "run_set_sale_solicitud",
    ]),

    ...mapActions("offices", ["getOffices"]),
    ...mapActions("report-sales", ["getSaleVoucher", "getSolicitudVoucher"]),
    showOptionCrud() {
      this.show_options_crud = this.selectedRows.length > 0;
      if (this.show_options_crud) {
        //let item = item.offices && item.offices.length == 1 && item.offices[0].active
        let item = this.selectedRows[0];
        if (item.offices && item.offices.length == 1) {
          this.show_btn_active = !item.offices[0].active;
        }
        //this.show_btn_active = !this.selectedRows[0].active
      }
    },
    handleSelectItem(selected) {
      if (selected.value) {
        this.selectedRows.push(selected.item);
      } else {
        let index_found = ArrayTools.getIndexById(
          this.selectedRows,
          selected.item.id
        );
        if (index_found > -1) {
          this.selectedRows.splice(index_found, 1);
        }
      }
      this.showOptionCrud();
    },
    /*handleEdit() {
            let product = this.selectedRows[0];
            this.selectedRows = [];
            this.showOptionCrud();
            this.selectProduct(product);
            router.push('/app/logistica/datos-producto');
        },*/
    handleShowFilters() {
      this.$refs.filters.show();
    },
    handleInputSearchByEnter(KeyboardEvent) {
      //console.log(KeyboardEvent);
      if (KeyboardEvent.code == "Enter") {
        this.handleSearch();
      }
    },
    handleShowCreate() {
      //router.push('/app/logistica/datos-producto');
      // router.push("/app/atencion/datos-solicitud");
      router.push("/app/atencion/datos-solicitud-venta");
    },
    handleFilter(value) {
      // console.log("data para filtrar", value);
    },
    async handleSearch() {
      this.selectedRows = [];
      this.showOptionCrud();
      let filters = {
        office_id: this.office_id,
        name: this.search_sale,
      };

      await this.getSolicitudes(filters);
    },
    async handleChangeStatus() {
      let product = this.selectedRows[0];
      this.selectedRows = [];
      this.showOptionCrud();
      await this.change_status(product);
    },
    async handleDelete() {
      let product = this.selectedRows[0];
      await this.delete(product);
      this.selectedRows = [];
      this.showOptionCrud();
    },
    handleDownload() {
      this.$refs.downloadProducts.show();
    },
    handleUpload() {
      this.$refs.uploadProducts.show();
    },
    async handlePrintVoucher(item) {
      // console.log(item);
      // await this.getSaleVoucher(item.id);
      await this.getSolicitudVoucher(item.id);

      if (this.voucher_solicitud) {
        let content = await TicketToolsSolicitud.printWorkOrder(
          this.voucher_solicitud
        );
        this.printVoucher(content);
      }
    },
    async loadFirst() {
      let filters = {
        office_id: this.office_id,
      };
      const response = await SolicitudApi.get_all(filters);
      this.salesAux = response.data;
    },
    async hanleChangeFilter(value) {
      this.filterAux = value;
      await this.getSolicitudes(value);
      // const response = await SolicitudApi.get_all(value);
      // this.salesAux = response.data;
    },
    printVoucher(content) {
      $("<iframe>", { name: "voucheriframe", class: "printFrame" })
        .appendTo("body")
        .contents()
        .find("body")
        .append(content);

      window.frames["voucheriframe"].focus();

      setTimeout(() => {
        window.frames["voucheriframe"].print();
      }, 500);

      setTimeout(() => {
        $(".printFrame").remove();
      }, 1000);
    },

    async handleCancelInvoice(item) {
      await this.cancelSolicitud(item);
      // this.$refs.cancelInvoice.show(sale);
    },
  },
  created() {
    this.run_set_sale_solicitud([]);
    this.emptySales();
  },
  destroyed() {
    this.emptySales();
  },
};
</script>

<style scoped>
.section-categories {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  font-family: Roboto, sans-serif !important;
}

.header-table-products {
  vertical-align: baseline !important;
  padding-top: 5px !important;
}

.v-data-table-header > tr > th {
  color: #263238 !important;
  vertical-align: baseline !important;
  padding-top: 5px !important;
}
.sale-cancel {
  color: #f44336;
  font-weight: 600;
}
</style>
